import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  X,
  FileText,
  Download,
  Trash2,
  User,
 Clock,
  File,
  Upload,
  LoaderCircle,
} from "lucide-react";
import leaveService from "../../services/leaveService";

const LeaveApprovedDetailModal = ({ leave, onClose }) => {
 const fileInputRef = useRef(null);
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [description, setDescription] = useState("");
  const [wasUpdated, setWasUpdated] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [downloadingId, setDownloadingId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [attachmentToDelete, setAttachmentToDelete] = useState(null);
const canModifyAttachments = [
  "PENDING_MANAGER",
  "PENDING_HR",
].includes(leave?.status);
const reloadPageAfterAction = () => {
  window.location.reload();
};
  const getErrorMessage = (error, fallback) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;

    if (status === 401) return "Votre session a expiré. Veuillez vous reconnecter.";
   if (status === 403) return "Vous n'avez pas l'autorisation d'effectuer cette action.";
    if (status === 404) return "Le document demandé est introuvable ou a déjà été supprimé.";
    if (status === 413) return "Le fichier est trop volumineux.";
    if (!error?.response) {

      return "Impossible de contacter le serveur. Vérifiez votre connexion.";

    }
    return typeof detail === "string" ? detail : fallback;

  };
  const getStatusInfo = (status) => {
    const statuses = {
      PENDING_MANAGER: {
        label: "En attente du manager",
        color: "#92400e",
        background: "#fef3c7",
        icon: "clock",
      },
      PENDING_HR: {
        label: "En attente du RH",
        color: "#1d4ed8",
      background: "#dbeafe",
        icon: "clock",
      },
      APPROVED: {
        label: "Congé approuvé",
        color: "#047857",
        background: "#d1fae5",
        icon: "check",
      },
      REJECTED: {
        label: "Demande refusée",
        color: "#b91c1c",
        background: "#fee2e2",
        icon: "x",
      },
      CANCELLED: {

        label: "Demande annulée",
        color: "#475569",
        background: "#e2e8f0",
        icon: "minus",
      },
    };
    return statuses[status] || {
      label: status || "Statut inconnu",
      color: "#475569",
      background: "#f1f5f9",
      icon: "info",
    };
  };
  const formatDate = (value) => {

    if (!value) return "Non renseignée";
    const date = new Date(`${String(value).slice(0, 10)}T00:00:00`);



    if (Number.isNaN(date.getTime())) return "Non renseignée";



    return date.toLocaleDateString("fr-FR", {

      day: "2-digit",

      month: "long",

      year: "numeric",

    });

  };



  const statusInfo = getStatusInfo(leave?.status);



  const approverLabel = {

    PENDING_MANAGER: "Prochaine étape",

    PENDING_HR: "Prochaine étape",

    APPROVED: "Décision finale",

    REJECTED: "Décision",

    CANCELLED: "Décision",

  }[leave?.status] || "Suivi";



  const approverValue = {

    PENDING_MANAGER: "En attente de validation du manager",

    PENDING_HR: "En attente de validation du service RH",

    APPROVED: leave?.hr_name || "Demande approuvée",

    REJECTED: leave?.rejected_by_name || "Demande refusée",

    CANCELLED: "Demande annulée",

  }[leave?.status] || "Information non disponible";



  const loadAttachments = useCallback(async () => {

    if (!leave?.id) return;



    setLoading(true);

    setErrorMessage("");



    try {

      const result = await leaveService.getAdditionalAttachments(leave.id);

      setAttachments(Array.isArray(result) ? result : []);

    } catch (error) {

      console.error("Erreur de chargement des pièces jointes :", error);

      setErrorMessage(

        getErrorMessage(error, "Impossible de charger les pièces jointes complémentaires.")

      );

    } finally {

      setLoading(false);

    }

  }, [leave?.id]);



  useEffect(() => {

    loadAttachments();

  }, [loadAttachments]);



  const handleUpload = async (event) => {

    event.preventDefault();



    if (!fileToUpload) {

      setErrorMessage("Veuillez sélectionner un fichier.");

      return;

    }



    const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];

    const validType =

      allowedTypes.includes(fileToUpload.type) ||

      /\.(pdf|jpe?g|png)$/i.test(fileToUpload.name);



    if (!validType) {

      setErrorMessage("Format non autorisé. Choisissez un fichier PDF, JPG ou PNG.");

      return;

    }



    setUploading(true);

    setErrorMessage("");

    setSuccessMessage("");



    try {

      await leaveService.uploadAdditionalAttachment(

        leave.id,

        fileToUpload,

        description.trim()

      );



      setFileToUpload(null);

      setDescription("");

      setWasUpdated(true);
window.location.reload();
      setSuccessMessage("La pièce jointe a été ajoutée avec succès.");



      // Réinitialiser le champ fichier après un ajout réussi.

      if (fileInputRef.current) fileInputRef.current.value = "";



      await loadAttachments();
          // Actualiser la page pour mettre à jour le bouton Approuver.
      window.location.reload();

    } catch (error) {

      console.error("Erreur d'ajout de pièce jointe :", error);

      setErrorMessage(

        getErrorMessage(error, "L'ajout du fichier a échoué. Veuillez réessayer.")

      );

    } finally {

      setUploading(false);

    }

  };



  const saveBlob = (blob, filename) => {

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.download = filename || "piece-jointe";

    document.body.appendChild(link);

    link.click();

    link.remove();



    // Éviter de révoquer l'URL avant que le navigateur démarre le téléchargement.

    window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);

  };



  const handleDownloadMain = async () => {

    setErrorMessage("");

    setSuccessMessage("");



    try {

      const blob = await leaveService.downloadAttachment(leave.id);

      if (!(blob instanceof Blob) || blob.size === 0) {

        throw new Error("Le fichier téléchargé est vide ou invalide.");

      }

      saveBlob(blob, leave.attachment_original_name || "document-initial");

    } catch (error) {

      console.error("Erreur de téléchargement du document initial :", error);

      setErrorMessage(

        getErrorMessage(error, "Le téléchargement du document initial a échoué.")

      );

    }

  };



  const handleDownloadAdditional = async (attachment) => {

    if (!attachment?.id) {

      setErrorMessage("Impossible de télécharger ce document : identifiant absent.");

      return;

    }



    setDownloadingId(attachment.id);

    setErrorMessage("");

    setSuccessMessage("");



    try {

      const blob = await leaveService.downloadAdditionalAttachment(attachment.id);

      if (!(blob instanceof Blob) || blob.size === 0) {

        throw new Error("Le fichier téléchargé est vide ou invalide.");

      }

      saveBlob(

        blob,

        attachment.original_file_name || `piece-jointe-${attachment.id}`

      );

    } catch (error) {

      console.error("Erreur de téléchargement de la pièce jointe :", error);

      setErrorMessage(

        getErrorMessage(error, "Le téléchargement du document a échoué.")

      );

    } finally {

      setDownloadingId(null);

    }

  };



  const handleDeleteAdditional = (attachment) => {

    if (!attachment?.id) {

      setErrorMessage("Impossible de supprimer ce document : identifiant absent.");

      return;

    }

    setAttachmentToDelete(attachment);

  };



  const confirmDeleteAdditional = async () => {

    const attachment = attachmentToDelete;

    if (!attachment?.id) {

      setAttachmentToDelete(null);

      return;

    }



    setDeletingId(attachment.id);

    setErrorMessage("");

    setSuccessMessage("");



    try {

      await leaveService.deleteAdditionalAttachment(attachment.id);

      setAttachments((current) =>

        current.filter((item) => item.id !== attachment.id)

      );
      window.location.reload();

      setWasUpdated(true);

      setSuccessMessage("La pièce jointe a été supprimée avec succès.");

      setAttachmentToDelete(null);

    } catch (error) {

      console.error("Erreur de suppression de pièce jointe :", error);

      setErrorMessage(

        getErrorMessage(error, "La suppression a échoué. Veuillez réessayer.")

      );

      setAttachmentToDelete(null);

    } finally {

      setDeletingId(null);

    }

  };



  const handleClose = () => onClose(wasUpdated);



  if (!leave) return null;



  return (

    <div className="modal-overlay" onClick={handleClose}>

      <div

        className="modal-form"

        role="dialog"

        aria-modal="true"

        aria-labelledby="leave-approved-title"

        onClick={(event) => event.stopPropagation()}

        style={{

          maxWidth: "1100px",

          width: "95vw",

          maxHeight: "90vh",

          display: "flex",

          flexDirection: "column",

        }}

      >

        <div

          className="form-header"

          style={{

            display: "flex",

            justifyContent: "space-between",

            alignItems: "center",

            paddingBottom: "20px",

            borderBottom: "1px solid #e2e8f0",

          }}

        >



<div

  style={{

    display: "flex",

    alignItems: "center",

    gap: "14px",

    minWidth: 0,

  }}

>

  <div

    style={{

      width: "46px",

      height: "46px",

      flexShrink: 0,

      display: "grid",

      placeItems: "center",

      borderRadius: "14px",

      background: "#eef2ff",

      color: "#4f46e5",

    }}

  >

    <FileText size={23} />

  </div>



  <div>

    <h3

      id="leave-approved-title"

      style={{

        margin: 0,

        fontSize: "1.2rem",

        fontWeight: 750,

        color: "#0f172a",

      }}

    >

      Détails de la demande de congé

    </h3>



    <div style={{ marginTop: "5px", color: "#64748b", fontSize: "0.85rem" }}>

      Référence : #{leave.id}

    </div>

  </div>

</div>



<span

  style={{

    display: "inline-flex",

    alignItems: "center",

    padding: "8px 12px",

    borderRadius: "999px",

    background: statusInfo.background,

    color: statusInfo.color,

    fontSize: "0.78rem",

    fontWeight: 700,

    whiteSpace: "nowrap",

  }}

>

  {statusInfo.label}

</span>



          <button

            type="button"

            onClick={handleClose}

            className="btn-close"

            aria-label="Fermer"

          >

            <X size={20} />

          </button>

        </div>



        <div style={{ padding: "28px", overflowY: "auto", flex: 1 }}>

          {errorMessage && (

            <div

              role="alert"

              style={{

                marginBottom: "16px",

                padding: "12px 16px",

                borderRadius: "8px",

                background: "#fef2f2",

                color: "#b91c1c",

                border: "1px solid #fecaca",

              }}

            >

              {errorMessage}

              <button

                type="button"

                onClick={() => setErrorMessage("")}

                aria-label="Fermer le message"

                style={{ float: "right", color: "inherit" }}

              >

                <X size={16} />

              </button>

            </div>

          )}



          {successMessage && (

            <div

              role="status"

              style={{

                marginBottom: "16px",

                padding: "12px 16px",

                borderRadius: "8px",

                background: "#f0fdf4",

                color: "#166534",

                border: "1px solid #bbf7d0",

              }}

            >

              {successMessage}

            </div>

          )}



          <style>{`

            .leave-detail-grid {

              display: grid;

              grid-template-columns: 1fr 1fr;

              gap: 24px;

              margin-bottom: 32px;

            }

            .leave-file-actions {

              display: flex;

              align-items: center;

              gap: 8px;

              flex-shrink: 0;

            }

            .leave-file-button {

              display: inline-flex;

              align-items: center;

              justify-content: center;

              min-width: 38px;

              min-height: 38px;

              border: 1px solid #e2e8f0;

              border-radius: 8px;

              background: white;

              cursor: pointer;

            }

            .leave-file-button:disabled {

              opacity: 0.5;

              cursor: wait;

            }

            .delete-confirm-backdrop {

              position: fixed;

              inset: 0;

              z-index: 2000;

              display: flex;

              align-items: center;

              justify-content: center;

              padding: 20px;

              background: rgba(15, 23, 42, 0.58);

              backdrop-filter: blur(4px);

              animation: deleteFadeIn 150ms ease-out;

            }

            .delete-confirm-dialog {

              width: min(100%, 440px);

              overflow: hidden;

              border: 1px solid #e2e8f0;

              border-radius: 18px;

              background: #ffffff;

              box-shadow: 0 24px 70px rgba(15, 23, 42, 0.28);

              animation: deleteSlideIn 180ms ease-out;

            }

            @keyframes deleteFadeIn {

              from { opacity: 0; }

              to { opacity: 1; }

            }

            @keyframes deleteSlideIn {

              from { opacity: 0; transform: translateY(8px) scale(.98); }

              to { opacity: 1; transform: translateY(0) scale(1); }

            }

            @media (prefers-reduced-motion: reduce) {

              .delete-confirm-backdrop, .delete-confirm-dialog { animation: none; }

            }

            @media (max-width: 768px) {

              .leave-detail-grid { grid-template-columns: 1fr; }

              .leave-file-row { gap: 12px !important; padding: 12px !important; }

            }

          `}</style>



          <div className="leave-detail-grid">

            <div

              className="card"

              style={{

                padding: "24px",

                backgroundColor: "#f8fafc",

                boxShadow: "none",

                border: "1px solid #e2e8f0",

                borderRadius: "12px",

              }}

            >

              <h4

                style={{

                  marginBottom: "18px",

                  display: "flex",

                  alignItems: "center",

                  gap: "8px",

                  color: "#334155",

                }}

              >

                <User size={18} /> Information Employé

              </h4>

              <p><strong>Nom :</strong> {leave.employee_name}</p>

              <p><strong>Type :</strong> {leave.leave_type_name}</p>

              <p><strong>Raison :</strong> {leave.reason || "Non renseignée"}</p>

            </div>



            <div

              className="card"

              style={{

                padding: "24px",

                backgroundColor: "#f8fafc",

                boxShadow: "none",

                border: "1px solid #e2e8f0",

                borderRadius: "12px",

              }}

            >

              <h4

                style={{

                  marginBottom: "18px",

                  display: "flex",

                  alignItems: "center",

                  gap: "8px",

                  color: "#334155",

                }}

              >

                <Clock size={18} /> Détails de Validation

              </h4>

              <p>

                <strong>Dates :</strong>{" "}

                Du {new Date(leave.start_date).toLocaleDateString("fr-FR")} au{" "}

                {new Date(leave.end_date).toLocaleDateString("fr-FR")}

              </p>

              <p><strong>Durée :</strong> {leave.duration_days} jour(s)</p>

              <p>

                  <strong>Suivi :</strong>{" "}

                  {leave.status === "PENDING_MANAGER"

                    ? "En attente du manager"

                    : leave.status === "PENDING_HR"

                      ? "En attente de validation RH"

                      : leave.status === "APPROVED"

                        ? `Validé par : ${leave.hr_name || "RH"}`

                        : leave.status === "REJECTED"

                          ? `Refusé${leave.rejected_by_name ? ` par : ${leave.rejected_by_name}` : ""}`

                          : leave.status === "CANCELLED"

                            ? "Demande annulée"

                            : "Statut non disponible"}

                </p>

            </div>

          </div>



          <section style={{ marginBottom: "32px" }}>

            <h4

              style={{

                fontSize: "1.1rem",

                marginBottom: "18px",

                color: "#334155",

                borderBottom: "1px solid #e2e8f0",

                paddingBottom: "10px",

              }}

            >

              Pièces Jointes

            </h4>



            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>

              {leave.attachment_path && (

                <div

                  className="leave-file-row"

                  style={{

                    display: "flex",

                    alignItems: "center",

                    justifyContent: "space-between",

                    gap: "16px",

                    padding: "16px 20px",

                    backgroundColor: "#f1f5f9",

                    borderRadius: "10px",

                    border: "1px solid #cbd5e1",

                  }}

                >

                  <div

                    style={{

                      display: "flex",

                      alignItems: "center",

                      gap: "14px",

                      minWidth: 0,

                    }}

                  >

                    <FileText size={20} color="#3b82f6" />

                    <div style={{ overflowWrap: "anywhere" }}>

                      <div style={{ fontWeight: 500 }}>

                        {leave.attachment_original_name || "Document initial"}

                      </div>

                      <div style={{ fontSize: "0.8rem", color: "#64748b" }}>

                        Document initial de la demande

                      </div>

                    </div>

                  </div>

                  <button

                    type="button"

                    onClick={handleDownloadMain}

                    className="leave-file-button"

                    title="Télécharger le document initial"

                    aria-label="Télécharger le document initial"

                  >

                    <Download size={18} color="#64748b" />

                  </button>

                </div>

              )}



              {loading ? (

                <div style={{ padding: "16px", textAlign: "center", color: "#64748b" }}>

                  <LoaderCircle

                    size={18}

                    style={{ verticalAlign: "middle", marginRight: "8px" }}

                  />

                  Chargement des pièces jointes...

                </div>

              ) : attachments.length > 0 ? (

                attachments.map((att) => (

                  <div

                    key={att.id}

                    className="leave-file-row"

                    style={{

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "space-between",

                      gap: "16px",

                      padding: "16px 20px",

                      backgroundColor: "#fff",

                      borderRadius: "10px",

                      border: "1px solid #e2e8f0",

                    }}

                  >

                    <div

                      style={{

                        display: "flex",

                        alignItems: "center",

                        gap: "14px",

                        minWidth: 0,

                      }}

                    >

                      <File size={20} color="#64748b" />

                      <div style={{ minWidth: 0, overflowWrap: "anywhere" }}>

                        <div style={{ fontWeight: 500, fontSize: "0.95rem" }}>

                          {att.original_file_name || "Pièce jointe"}

                        </div>

                        <div style={{ fontSize: "0.8rem", color: "#64748b" }}>

                          {att.description ? `${att.description} · ` : ""}

                          {att.uploaded_at

                            ? `Ajouté le ${new Date(att.uploaded_at).toLocaleDateString("fr-FR")}`

                            : "Date non renseignée"}

                        </div>

                      </div>

                    </div>



                    {/* Les actions utilisent att uniquement dans cette boucle. */}

                    <div className="leave-file-actions">

                      <button

                        type="button"

                        onClick={() => handleDownloadAdditional(att)}

                        className="leave-file-button"

                        title="Télécharger la pièce jointe"

                        aria-label={`Télécharger ${att.original_file_name || "le document"}`}

                        disabled={downloadingId === att.id}

                      >

                        {downloadingId === att.id ? (

                          <LoaderCircle size={18} />

                        ) : (

                          <Download size={18} color="#64748b" />

                        )}

                      </button>



                      <button

                        type="button"

                        onClick={() => handleDeleteAdditional(att)}

                        className="leave-file-button"

                        title="Supprimer la pièce jointe"

                        aria-label={`Supprimer ${att.original_file_name || "le document"}`}

                        disabled={deletingId === att.id}

                        style={{ color: "#dc2626" }}

                      >

                        {deletingId === att.id ? (

                          <LoaderCircle size={18} />

                        ) : (

                          <Trash2 size={18} />

                        )}

                      </button>

                    </div>

                  </div>

                ))

              ) : (

                !leave.attachment_path && (

                  <div

                    style={{

                      padding: "20px",

                      textAlign: "center",

                      backgroundColor: "#f8fafc",

                      borderRadius: "10px",

                      border: "1px dashed #cbd5e1",

                      color: "#64748b",

                    }}

                  >

                    Aucune pièce jointe pour ce congé.

                  </div>

                )

              )}

            </div>

          </section>



          <section

            style={{

              backgroundColor: "#f8fafc",

              padding: "24px",

              borderRadius: "12px",

              border: "1px solid #e2e8f0",

            }}

          >

            <h4 style={{ fontSize: "1rem", marginBottom: "18px", color: "#334155" }}>

              Ajouter un document complémentaire

            </h4>



            <form onSubmit={handleUpload}>

              <div style={{ display: "grid", gap: "18px", marginBottom: "18px" }}>

                <div className="form-group">

                  <label className="form-label" htmlFor="additional-attachment">

                    Fichier (PDF ou image JPG/PNG)

                  </label>

                  <input

                    ref={fileInputRef}

                    id="additional-attachment"

                    type="file"

                    className="form-input"

                    onChange={(event) =>

                      setFileToUpload(event.target.files?.[0] || null)

                    }

                    accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"

                    required

                    disabled={uploading}

                    style={{ padding: "12px 16px" }}

                  />

                </div>



                <div className="form-group">

                  <label className="form-label" htmlFor="attachment-description">

                    Description (optionnelle)

                  </label>

                  <input

                    id="attachment-description"

                    type="text"

                    className="form-input"

                    placeholder="Ex. : Certificat d'hospitalisation"

                    value={description}

                    onChange={(event) => setDescription(event.target.value)}

                    disabled={uploading}

                    maxLength={500}

                    style={{ padding: "12px 16px" }}

                  />

                </div>

              </div>



              <button

                type="submit"

                className="btn btn-primary"

                disabled={uploading || !fileToUpload}

                style={{

                  display: "inline-flex",

                  alignItems: "center",

                  justifyContent: "center",

                  gap: "8px",

                  opacity: uploading || !fileToUpload ? 0.65 : 1,

                }}

              >

                {uploading ? (

                  <>

                    <LoaderCircle size={18} />

                    Ajout en cours...

                  </>

                ) : (

                  <>

                    <Upload size={18} />

                    Ajouter la pièce jointe

                  </>

                )}

              </button>

            </form>

          </section>

        </div>

      </div>



      {attachmentToDelete && (

        <div

          className="delete-confirm-backdrop"

          onClick={() => deletingId === null && setAttachmentToDelete(null)}

        >

          <div

            className="delete-confirm-dialog"

            role="alertdialog"

            aria-modal="true"

            aria-labelledby="delete-attachment-title"

            aria-describedby="delete-attachment-description"

            onClick={(event) => event.stopPropagation()}

          >

            <div style={{ padding: "24px 24px 18px" }}>

              <div

                style={{

                  display: "flex",

                  alignItems: "flex-start",

                  gap: "14px",

                }}

              >

                <div

                  style={{

                    width: "46px",

                    height: "46px",
                    flex: "0 0 46px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "14px",
                    background: "#fef2f2",
                    color: "#dc2626",
                  }}
                >
                  <Trash2 size={22} />
                </div>
                <div style={{ minWidth: 0, flex: 1 }}>

                  <h3

                    id="delete-attachment-title"
                    style={{
                      margin: "2px 0 8px",
                      color: "#0f172a",
                      fontSize: "1.1rem",
                      fontWeight: 700,
                    }}
                  >
                    Supprimer cette pièce jointe ?
                  </h3>
                  <p
                    id="delete-attachment-description"
                    style={{
                      margin: 0,
                      color: "#475569",
                      fontSize: "0.93rem",
                      lineHeight: 1.6,
                    overflowWrap: "anywhere",
                    }}
                  >
                  Voulez-vous vraiment supprimer{" "}
                    <strong style={{ color: "#1e293b" }}>
                      « {attachmentToDelete.original_file_name || "ce document"} »
                    </strong>
                    ?
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => setAttachmentToDelete(null)}
                  disabled={deletingId !== null}
                  aria-label="Fermer la confirmation"
                  style={{
                    border: 0,
                    background: "transparent",
                    color: "#64748b",
                    cursor: "pointer",
                   padding: "4px",
                  }}
                >
                  <X size={20} />
                </button>
              </div>
           <div

                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                marginTop: "20px",
                  padding: "11px 12px",
                  borderRadius: "10px",
                  background: "#fff7ed",

                  color: "#9a3412",

                  fontSize: "0.83rem",

                  lineHeight: 1.45,

                }}

              >

                <Clock size={17} style={{ flexShrink: 0 }} />

                Cette action est définitive. Le document ne pourra plus être récupéré.

              </div>

            </div>



            <div

              style={{

                display: "flex",

                justifyContent: "flex-end",

                flexWrap: "wrap",

                gap: "10px",

                padding: "16px 24px",

                borderTop: "1px solid #e2e8f0",

                background: "#f8fafc",

              }}

            >

              <button

                type="button"

                onClick={() => setAttachmentToDelete(null)}

                disabled={deletingId !== null}

                style={{

                  minHeight: "42px",

                  padding: "0 18px",

                  border: "1px solid #cbd5e1",

                  borderRadius: "10px",

                  background: "#fff",

                  color: "#334155",

                  fontWeight: 600,

                  cursor: deletingId !== null ? "wait" : "pointer",

                }}

              >

                Annuler

              </button>

              <button

                type="button"

                onClick={confirmDeleteAdditional}

                disabled={deletingId !== null}

                style={{

                  minHeight: "42px",

                  display: "inline-flex",

                  alignItems: "center",

                  justifyContent: "center",

                  gap: "8px",

                  padding: "0 18px",

                  border: "1px solid #b91c1c",

                  borderRadius: "10px",

                  background: "#dc2626",

                  color: "#fff",

                  fontWeight: 600,

                  cursor: deletingId !== null ? "wait" : "pointer",

                  opacity: deletingId !== null ? 0.7 : 1,

                }}

              >

                {deletingId !== null ? (

                  <>

                    <LoaderCircle size={17} />

                    Suppression...

                  </>

                ) : (

                  <>

                    <Trash2 size={17} />

                    Supprimer définitivement

                  </>

                )}

              </button>

            </div>

          </div>

        </div>

      )}

    </div>

  );

};



export default LeaveApprovedDetailModal;
